import { useTranslation } from 'react-i18next';
import { CardBox } from '~/components/ui/Card';
import { cn } from '~/lib/utils';
import useCurrentUser from '~/modules/user/useCurrentUser';
import AvatarSection from './AvatarSection';
import NameSection from './NameSection';

export default function ProfileOverview({ overview = false }: { overview?: boolean }) {
  const { t } = useTranslation();
  const user = useCurrentUser();
  const displayName =
    [user?.first_name, user?.last_name].filter(Boolean).join(' ') || user?.username || '—';
  const handle = user?.username ? `@${user.username.replace(/^@/, '')}` : '—';

  return (
    <CardBox
      className={cn(
        'flex items-center gap-6 p-7',
        overview
          ? 'compact:p-4 compact:gap-3.5 max-xs:p-3 max-xs:gap-3'
          : 'compact:px-3.5 compact:py-3 compact:gap-3',
      )}
    >
      <AvatarSection overview={overview} />
      {!overview && (
        <span className="hidden compact:block flex-1 text-[15px] text-body">
          {t('account.photo')}
        </span>
      )}
      <div className={cn('min-w-0 flex-1', !overview && 'compact:hidden')}>
        <h2 className="truncate text-[27px] leading-[1.2] tracking-[-0.6px] compact:text-[21px] compact:tracking-[-0.3px] compact:whitespace-normal compact:wrap-anywhere max-xs:text-[19px]">
          {displayName}
        </h2>
        <p className="mt-2 truncate text-[14px] text-body compact:mt-1 compact:text-[13px] compact:leading-normal compact:whitespace-normal compact:wrap-anywhere">
          {user?.email || '—'}
        </p>
        <p className="mt-2 truncate text-[13px] text-gray-3 compact:mt-1 compact:text-xs compact:leading-normal compact:whitespace-normal compact:wrap-anywhere">
          {handle}
        </p>
      </div>
      <div className="compact:hidden">
        <NameSection variant="overview" />
      </div>
    </CardBox>
  );
}
